export const functionalitiesPage = {
  // SEO
  'functionalitiesPage.seo.title': 'Subvention360 Features - Public Funding Management Platform',
  'functionalitiesPage.seo.description': 'Discover Subvention360 features: {count}+ grants, automatic matching, file tracking, team collaboration and professional PDF exports.',
  'functionalitiesPage.seo.keywords': 'subvention360 features, public funding platform, subsidy matching, grant management, PDF export',

  // Header Navigation
  'functionalitiesPage.nav.features': 'Features',
  'functionalitiesPage.nav.pricing': 'Pricing',
  'functionalitiesPage.nav.login': 'Sign In',
  'functionalitiesPage.nav.trial': 'Trial',
  'functionalitiesPage.nav.dashboard': 'Dashboard',

  // Hero Section
  'functionalitiesPage.hero.title': 'Subvention360 Platform',
  'functionalitiesPage.hero.subtitle': 'All the tools to master public funding in one place',
  'functionalitiesPage.hero.description': 'A complete suite designed specifically for consulting, audit, and accounting professionals.',
  'functionalitiesPage.hero.pricing': 'From €49/month',
  'functionalitiesPage.hero.viewPricing': 'View all pricing →',

  // Demo Carousel
  'functionalitiesPage.demo.title': 'See the platform in action',
  'functionalitiesPage.demo.subtitle': 'Click on each feature to see how it works',
  'functionalitiesPage.demo.siret.title': 'Client File Creation',
  'functionalitiesPage.demo.siret.description': 'Enter a SIRET and automatically retrieve company information',
  'functionalitiesPage.demo.assistant.title': 'AI Assistant',
  'functionalitiesPage.demo.assistant.description': 'Ask your questions and let the AI guide you in your research',
  'functionalitiesPage.demo.search.title': 'Grant Search',
  'functionalitiesPage.demo.search.description': 'Filter by region, sector, amount and find the right programs',
  'functionalitiesPage.demo.matching.title': 'Eligibility Score',
  'functionalitiesPage.demo.matching.description': 'Each grant is scored from 0 to 100% based on your client\'s profile',
  'functionalitiesPage.demo.export.title': 'PDF Export',
  'functionalitiesPage.demo.export.description': 'Generate professional reports with your logo and contact details',
  'functionalitiesPage.demo.email.title': 'Email Sending',
  'functionalitiesPage.demo.email.description': 'AI-generated personalized email with the report attached',
  'functionalitiesPage.demo.placeholder': 'Demo GIF to add',

  // Overview Features
  'functionalitiesPage.overview.database.title': 'Comprehensive Database',
  'functionalitiesPage.overview.database.description': '{count}+ French and European funding sources, updated weekly',
  'functionalitiesPage.overview.identification.title': 'Automatic Identification',
  'functionalitiesPage.overview.identification.description': 'Find eligible grants for each client in seconds',
  'functionalitiesPage.overview.tracking.title': 'File Tracking',
  'functionalitiesPage.overview.tracking.description': 'Dashboard to manage all your funding assignments',
  'functionalitiesPage.overview.security.title': 'Enhanced Security',
  'functionalitiesPage.overview.security.description': 'GDPR, secure EU hosting, data encryption',

  // Capabilities Table
  'functionalitiesPage.capabilities.title': 'Platform Capabilities Overview',
  'functionalitiesPage.capabilities.subtitle': 'Technical specifications and guaranteed performance',
  'functionalitiesPage.capabilities.feature': 'Feature',
  'functionalitiesPage.capabilities.capacity': 'Capacity',
  'functionalitiesPage.capabilities.detail': 'Detail',

  'functionalitiesPage.capabilities.database.feature': 'Database',
  'functionalitiesPage.capabilities.database.capacity': '{count}+ funding sources',
  'functionalitiesPage.capabilities.database.detail': 'Grants, loans, advances, R&D tax credits, tax relief',

  'functionalitiesPage.capabilities.update.feature': 'Updates',
  'functionalitiesPage.capabilities.update.capacity': 'Weekly',
  'functionalitiesPage.capabilities.update.detail': 'New programs and modifications',

  'functionalitiesPage.capabilities.clients.feature': 'Client Files',
  'functionalitiesPage.capabilities.clients.capacity': '2 types + import',
  'functionalitiesPage.capabilities.clients.detail': 'SIRET, creation project, or Excel/CSV import',

  'functionalitiesPage.capabilities.ai.feature': 'AI Assistant',
  'functionalitiesPage.capabilities.ai.capacity': 'Integrated',
  'functionalitiesPage.capabilities.ai.detail': 'Questions, writing assistance, creation guide',

  'functionalitiesPage.capabilities.score.feature': 'Eligibility Score',
  'functionalitiesPage.capabilities.score.capacity': 'Automatic',
  'functionalitiesPage.capabilities.score.detail': 'Score from 0 to 100% per grant',

  'functionalitiesPage.capabilities.tracking.feature': 'File Tracking',
  'functionalitiesPage.capabilities.tracking.capacity': 'Dashboard',
  'functionalitiesPage.capabilities.tracking.detail': 'By client or by assignment',

  'functionalitiesPage.capabilities.team.feature': 'Team Work',
  'functionalitiesPage.capabilities.team.capacity': 'Multi-collaborator',
  'functionalitiesPage.capabilities.team.detail': 'Role-based access rights',

  'functionalitiesPage.capabilities.reports.feature': 'Reports & Email',
  'functionalitiesPage.capabilities.reports.capacity': 'PDF + AI sending',
  'functionalitiesPage.capabilities.reports.detail': 'Logo, contact details, AI-generated email content',

  'functionalitiesPage.capabilities.compliance.feature': 'Compliance',
  'functionalitiesPage.capabilities.compliance.capacity': 'GDPR',
  'functionalitiesPage.capabilities.compliance.detail': 'Data hosted in Europe',

  'functionalitiesPage.capabilities.support.feature': 'Support',
  'functionalitiesPage.capabilities.support.capacity': 'Email',
  'functionalitiesPage.capabilities.support.detail': 'Response within 48 business hours',

  // Search & Discovery Section
  'functionalitiesPage.search.title': 'Intelligent Search & Discovery',
  'functionalitiesPage.search.subtitle': 'Comprehensive database of {count}+ public funding sources',
  'functionalitiesPage.search.weekly.title': 'Updated weekly',
  'functionalitiesPage.search.weekly.description': 'New programs, criteria changes and deadlines always up to date.',
  'functionalitiesPage.search.weekly.feature1': 'Search by multiple criteria simultaneously',
  'functionalitiesPage.search.weekly.feature2': 'Filters by business sector, region, amount, grant type',
  'functionalitiesPage.search.smart.title': 'Search that understands your business',
  'functionalitiesPage.search.smart.description': 'Type "youth hiring" and also find "apprenticeship contract", "first job assistance", etc.',
  'functionalitiesPage.search.smart.feature1': 'National, regional and European grants',
  'functionalitiesPage.search.smart.feature2': 'Notification when new programs match your clients',

  // AI Analysis Section
  'functionalitiesPage.ai.title': 'Automatic Profile Analysis',
  'functionalitiesPage.ai.subtitle': 'Grants adapted to each client, automatically identified',
  'functionalitiesPage.ai.score.title': 'Clear eligibility score',
  'functionalitiesPage.ai.score.description': 'Each grant is scored from 0 to 100% based on the match with your client\'s profile.',
  'functionalitiesPage.ai.score.feature1': 'Prioritize files with the best potential',
  'functionalitiesPage.ai.score.feature2': 'Most relevant grants at the top of the list',
  'functionalitiesPage.ai.history.title': 'File history',
  'functionalitiesPage.ai.history.description': 'Keep track of past applications and results obtained for each client.',
  'functionalitiesPage.ai.history.feature1': 'Tracking of accepted and rejected files',
  'functionalitiesPage.ai.history.feature2': 'Amounts obtained by client and by year',
  'functionalitiesPage.ai.history.feature3': 'Statistics to highlight your support',
  'functionalitiesPage.ai.time.title': 'Concrete time savings',
  'functionalitiesPage.ai.time.description': 'Go from 2-3 hours of research per client to just a few minutes.',
  'functionalitiesPage.ai.time.feature1': 'Grant identification in seconds',
  'functionalitiesPage.ai.time.feature2': 'More time for high-value consulting',

  // Tracking Section
  'functionalitiesPage.tracking.title': 'Assignment Tracking',
  'functionalitiesPage.tracking.subtitle': 'Dashboard to manage all your funding files',
  'functionalitiesPage.tracking.overview.title': 'Overview of your activity',
  'functionalitiesPage.tracking.overview.feature1': 'Total funding in progress and number of active files',
  'functionalitiesPage.tracking.overview.feature2': 'Automatic alerts for deadlines less than 7 days away',
  'functionalitiesPage.tracking.kanban.title': 'Board with 3 columns: To Study, In Preparation, Submitted',
  'functionalitiesPage.tracking.kanban.feature1': 'Move your files from one stage to another in one click',
  'functionalitiesPage.tracking.kanban.feature2': 'Amount, client and next action visible on each file',

  // Collaboration Section
  'functionalitiesPage.collaboration.title': 'Advanced Team Collaboration',
  'functionalitiesPage.collaboration.subtitle': 'Secure collaborative work environment',
  'functionalitiesPage.collaboration.sharing.title': 'Share work between collaborators',
  'functionalitiesPage.collaboration.sharing.feature1': 'Each collaborator accesses their clients and files',
  'functionalitiesPage.collaboration.sharing.feature2': 'Configurable access rights: read-only, edit, admin',
  'functionalitiesPage.collaboration.traceability.title': 'Complete traceability',
  'functionalitiesPage.collaboration.traceability.feature1': 'Shared dashboard: see where all files stand',
  'functionalitiesPage.collaboration.traceability.feature2': 'Modification history: who did what and when',

  // Reports Section
  'functionalitiesPage.reports.title': 'History & Reports',
  'functionalitiesPage.reports.subtitle': 'Keep track of your files and present your results',
  'functionalitiesPage.reports.tracking.title': 'Application tracking',
  'functionalitiesPage.reports.tracking.feature1': 'History of files submitted by client',
  'functionalitiesPage.reports.tracking.feature2': 'Amounts obtained recorded for each file',
  'functionalitiesPage.reports.pdf.title': 'PDF Reports',
  'functionalitiesPage.reports.pdf.feature1': 'Export with your logo and firm contact details',
  'functionalitiesPage.reports.pdf.feature2': 'List of eligible grants ready to send to client',

  // Security Section
  'functionalitiesPage.security.title': 'Security & Compliance',
  'functionalitiesPage.security.subtitle': 'Your data protected and compliant with regulations',
  'functionalitiesPage.security.hosting.title': 'Hosting & Encryption',
  'functionalitiesPage.security.hosting.feature1': 'Data encryption - Protection of your sensitive information',
  'functionalitiesPage.security.hosting.feature2': 'Hosted on Supabase (SOC 2 infrastructure) - Servers in European Union',
  'functionalitiesPage.security.compliance.title': 'Compliance & Audits',
  'functionalitiesPage.security.compliance.feature1': 'Full GDPR compliance - Strict adherence to European regulations',
  'functionalitiesPage.security.compliance.feature2': 'Detailed audit trails - Complete access traceability',

  // Key Features Section
  'functionalitiesPage.keyFeatures.badge': 'Key features',
  'functionalitiesPage.keyFeatures.title': 'What you can do with Subvention360',
  'functionalitiesPage.keyFeatures.subtitle': 'Simple and effective tools to find and track your funding',

  'functionalitiesPage.keyFeatures.clients.title': 'Client Files',
  'functionalitiesPage.keyFeatures.clients.description': 'Create a client file in less than 30 seconds',
  'functionalitiesPage.keyFeatures.clients.feature1': 'Existing company: data automatically retrieved via SIRET',
  'functionalitiesPage.keyFeatures.clients.feature2': 'Creation project: AI assistant that guides step by step',
  'functionalitiesPage.keyFeatures.clients.feature3': 'Bulk import: upload your clients from Excel or CSV',

  'functionalitiesPage.keyFeatures.assistant.title': 'AI Assistant',
  'functionalitiesPage.keyFeatures.assistant.description': 'A virtual advisor to support you',
  'functionalitiesPage.keyFeatures.assistant.feature1': 'Ask your questions about grants and programs',
  'functionalitiesPage.keyFeatures.assistant.feature2': 'Help with writing and understanding criteria',
  'functionalitiesPage.keyFeatures.assistant.feature3': 'Interactive guide for business creation projects',

  'functionalitiesPage.keyFeatures.search.title': 'Grant Search',
  'functionalitiesPage.keyFeatures.search.description': 'Find programs adapted to each client',
  'functionalitiesPage.keyFeatures.search.feature1': 'Finds results even without exact terms',
  'functionalitiesPage.keyFeatures.search.feature2': 'Filters by region, sector, amount, grant type',
  'functionalitiesPage.keyFeatures.search.feature3': 'Search by business keywords',

  'functionalitiesPage.keyFeatures.identification.title': 'Automatic Identification',
  'functionalitiesPage.keyFeatures.identification.description': 'Eligible grants in seconds',
  'functionalitiesPage.keyFeatures.identification.feature1': 'Automatic analysis of company profile',
  'functionalitiesPage.keyFeatures.identification.feature2': 'Eligibility score from 0 to 100%',
  'functionalitiesPage.keyFeatures.identification.feature3': 'Ranking by relevance',

  'functionalitiesPage.keyFeatures.reportsEmail.title': 'Reports & Email Sending',
  'functionalitiesPage.keyFeatures.reportsEmail.description': 'Professional documents ready to share',
  'functionalitiesPage.keyFeatures.reportsEmail.feature1': 'PDF export with your logo and contact details',
  'functionalitiesPage.keyFeatures.reportsEmail.feature2': 'Email sending with AI-generated content',
  'functionalitiesPage.keyFeatures.reportsEmail.feature3': 'Sending history and saved contacts',

  'functionalitiesPage.keyFeatures.fileTracking.title': 'File Tracking',
  'functionalitiesPage.keyFeatures.fileTracking.description': 'Manage your funding assignments',
  'functionalitiesPage.keyFeatures.fileTracking.feature1': 'Visual dashboard with stages',
  'functionalitiesPage.keyFeatures.fileTracking.feature2': 'Move files from one column to another',
  'functionalitiesPage.keyFeatures.fileTracking.feature3': 'Alerts for upcoming deadlines',

  'functionalitiesPage.keyFeatures.teamwork.title': 'Team Work',
  'functionalitiesPage.keyFeatures.teamwork.description': 'Share files between collaborators',
  'functionalitiesPage.keyFeatures.teamwork.feature1': 'Shared access to client files',
  'functionalitiesPage.keyFeatures.teamwork.feature2': 'Role-based access rights (read, edit)',
  'functionalitiesPage.keyFeatures.teamwork.feature3': 'Modification history',

  // Final CTA
  'functionalitiesPage.cta.title': 'Ready to revolutionize your public funding support?',
  'functionalitiesPage.cta.subtitle': 'Join the firms already optimizing their grants service',
  'functionalitiesPage.cta.startNow': 'Start now',
  'functionalitiesPage.cta.viewPricing': 'View pricing',
  'functionalitiesPage.cta.badge1': 'Complete solution',
  'functionalitiesPage.cta.badge2': 'Consulting specialized',
  'functionalitiesPage.cta.badge3': 'Guaranteed security',
  'functionalitiesPage.cta.badge4': 'Email support included',
} as const;
